export default "__VITE_ASSET__BD9bmWX8__"